import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Chip,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { blogPosts } from '../pages/blog/blogData';

// Latest blog posts on the homepage (blogPosts is newest first)
const RecentProjects: React.FC = () => {
  const posts = blogPosts.slice(0, 3);
  if (posts.length === 0) return null;
  const single = posts.length === 1;

  return (
    <Box sx={{ py: 8 }}>
      <Container>
        <Box textAlign="center" mb={6}>
          <Typography variant="h2" component="h2" fontWeight={700} gutterBottom>
            Recent Projects
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '800px', mx: 'auto' }}>
            A look at real jobs we've done for homes and businesses around Northeast Wisconsin.
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {posts.map((post) => (
            <Grid item xs={12} sm={single ? 10 : 6} md={single ? 8 : 4} key={post.id}>
              <Card elevation={3} sx={{ height: '100%' }}>
                <CardActionArea
                  component={RouterLink}
                  to={`/blog/${post.slug}`}
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                >
                  <CardMedia
                    component="img"
                    image={post.featuredImage}
                    alt={post.title}
                    loading="lazy"
                    sx={{ height: single ? { xs: 220, sm: 320 } : 200, objectFit: 'cover' }}
                  />
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Chip label={post.category} size="small" color="primary" sx={{ mb: 1.5 }} />
                    <Typography variant="h5" component="h3" fontWeight={600} gutterBottom>
                      {post.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                      {post.excerpt}
                    </Typography>
                    <Typography variant="button" color="primary" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                      Read the story <ArrowForwardIcon fontSize="small" />
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box textAlign="center" mt={5}>
          <Button component={RouterLink} to="/blog" variant="outlined" color="primary" size="large">
            See all projects
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default RecentProjects;
